import { environment } from './environment';

export const authConfig = {
  region: environment.aws.region,
  domain: environment.aws.cognito.domain,
  clientId: environment.aws.cognito.clientId,
  redirectUri: window.location.origin,
  logoutUri: `${window.location.origin}/logout-success`,
};

export const getAuthorizeEndpoint = () => {
  const { domain, clientId, redirectUri } = authConfig;
  return `https://${domain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=openid+email+profile&redirect_uri=${encodeURIComponent(redirectUri)}`;
};

export const getTokenEndpoint = () => {
  return `https://${authConfig.domain}/oauth2/token`;
};

export const getLogoutEndpoint = () => {
  const { domain, clientId, logoutUri } = authConfig;
  return `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};